import React from 'react';
import {
  Accordion,
  AccordionProps,
  accordionSummaryClasses,
  cardHeaderClasses,
} from '@rossum/ui/material';

export const ActivityAccordion = React.forwardRef<
  HTMLDivElement | null,
  AccordionProps
>((props, ref) => (
  <Accordion
    {...props}
    ref={ref}
    sx={{
      scrollMargin: '16px',
      '&&': {
        marginBottom: '0px',
        marginTop: '8px',
      },
      [`.${accordionSummaryClasses.root}`]: {
        paddingLeft: 0,
      },
      [`&& .${accordionSummaryClasses.content}`]: {
        marginTop: '0px',
        marginBottom: '0px',
      },
      [`.${cardHeaderClasses.title}`]: theme => theme.typography.body1,
      ...props.sx,
    }}
  />
));
